var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{staticClass:"ma-auto",attrs:{"contain":"","max-width":"300","max-height":"300","width":_vm.width,"src":_vm.getImageSrc('eccipe_logo.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }